export default __webpack_public_path__ + "static/media/mint.049276b4.png";